<template>
  <div v-if="content" class="ai-platform-page hero-style-home">
    <div class="ai-hero-banner">
      <img
        :src="heroBannerSrc"
        alt=""
        srcset=""
        style="width: 100%"
        @load="loaded = true"
        :class="{ show: loaded }"
        class="top_img"
      />
      <div class="ai-hero-title">{{ solutionName }}</div>
    </div>

    <nav class="product-tabs-bar">
      <a
        class="product-tab"
        :class="{ active: activeTab === 'background' }"
        href="#background"
        @click.prevent="scrollTo('background')"
        >需求背景</a
      >
      <a
        class="product-tab"
        :class="{ active: activeTab === 'challenges' }"
        href="#challenges"
        @click.prevent="scrollTo('challenges')"
        >业务挑战</a
      >
      <a
        class="product-tab"
        :class="{ active: activeTab === 'scenarios' }"
        href="#scenarios"
        @click.prevent="scrollTo('scenarios')"
        >场景应用</a
      >
      <a
        v-if="SHOW_SOLUTION_DEPLOY_DIAGRAM"
        class="product-tab"
        :class="{ active: activeTab === 'architecture' }"
        href="#architecture"
        @click.prevent="scrollTo('architecture')"
        >部署示意图</a
      >
      <a
        class="product-tab"
        :class="{ active: activeTab === 'advantages' }"
        href="#advantages"
        @click.prevent="scrollTo('advantages')"
        >方案优势</a
      >
      <a
        class="product-tab"
        :class="{ active: activeTab === 'cases' }"
        href="#cases"
        @click.prevent="scrollTo('cases')"
        >典型案例</a
      >
    </nav>

    <div class="product-body">
    <section
      id="background"
      class="product-section section-row ai-platform-block"
      :class="{ 'animate-in': backgroundVisible }"
    >
      <div class="section-title">需求背景</div>
      <div class="section-content">
        <div class="background-card">
          <p class="case-text case-text-full" :class="{ 'no-dropcap': !dropcapEnabled }">{{ content.background }}</p>
        </div>
      </div>
    </section>

    <section
      id="challenges"
      class="product-section section-row ai-platform-block"
      :class="{ 'animate-in': challengesVisible }"
    >
      <div class="section-title">业务挑战</div>
      <div class="section-content">
      <div class="grid-2">
        <div v-for="(item, idx) in content.challenges" :key="item.title" class="card">
          <img
            class="card-icon"
            :src="challengeIcons[idx % challengeIcons.length]"
            alt=""
          />
          <div class="card-text">
            <div class="card-title">{{ item.title }}</div>
            <div class="card-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
      </div>
    </section>

    <section
      id="scenarios"
      class="product-section section-row ai-platform-block"
      :class="{ 'animate-in': scenariosVisible }"
    >
      <div class="section-title">场景应用</div>
      <div class="section-content">
      <div class="scenarios">
        <div class="scenario-text">
          <div
            v-for="(item, idx) in content.scenarios"
            :key="item.title"
            class="scenario-item"
            :class="{ highlight: idx === 1 }"
          >
            <div class="item-title">{{ item.title }}</div>
            <div class="item-desc">{{ item.desc }}</div>
          </div>
        </div>
        <img
          src="@/assets/jiejue/ai-tiaozhan/1.jpg"
          alt=""
          style="width: 50%; border-radius: 4px"
          class="mobile-hidden-img"
        />
      </div>
      </div>
    </section>

    <section
      v-if="SHOW_SOLUTION_DEPLOY_DIAGRAM"
      id="architecture"
      class="product-section section-row ai-platform-block"
      :class="{ 'animate-in': architectureVisible }"
    >
      <div class="section-title">部署示意图</div>
      <div class="section-content">
      <img
        :src="architectureSrc"
        alt="部署示意图"
        class="architecture-image"
      />
      <p class="architecture-caption">{{ content.architectureCaption }}</p>
      </div>
    </section>

    <section
      id="advantages"
      class="product-section section-row advantages ai-platform-block"
      :class="{ 'animate-in': advantagesVisible }"
    >
      <div class="section-title">方案优势</div>
      <div class="section-content">
      <div class="grid-5">
        <div v-for="(item, idx) in content.advantages" :key="item.title" class="adv-card">
          <img :src="advantageIcons[idx % advantageIcons.length]" alt="" class="adv-badge" />
          <div class="adv-title">{{ item.title }}</div>
          <div class="adv-desc">{{ item.desc }}</div>
        </div>
      </div>
      </div>
    </section>

    <section
      id="cases"
      class="product-section section-row ai-platform-block"
      :class="{ 'animate-in': casesVisible }"
    >
      <div class="section-title">典型案例</div>
      <div class="section-content section-content-cases">
        <div class="case-content case-content-blink">
          <h3 class="case-heading">{{ content.caseTitle }}</h3>
          <div class="case-section">
            <h3 class="case-subtitle">痛点</h3>
            <p class="case-text">{{ content.casePain }}</p>
          </div>
          <div class="case-section">
            <h3 class="case-subtitle">做法</h3>
            <p class="case-text">{{ content.caseApproach }}</p>
          </div>
          <div class="case-section">
            <h3 class="case-subtitle">成效</h3>
            <p class="case-text">{{ content.caseResult }}</p>
          </div>
        </div>
      </div>
    </section>
    </div>

    
  </div>
</template>

<script setup>
import { computed, ref, onMounted, onBeforeUnmount } from "vue";
import { useRoute } from "vue-router";
import { SHOW_SOLUTION_DEPLOY_DIAGRAM } from "@/data/solutionUi.js";
import { aiComputeSolutions } from "../../data/aiComputeSolutions";
import challengeIcon1 from "@/assets/jiejue/ai-tiaozhan/p1.svg";
import challengeIcon2 from "@/assets/jiejue/ai-tiaozhan/p2.svg";
import challengeIcon3 from "@/assets/jiejue/ai-tiaozhan/p3.svg";
import challengeIcon4 from "@/assets/jiejue/ai-tiaozhan/p4.svg";
import advantageIcon1 from "@/assets/jiejue/1.svg";
import advantageIcon2 from "@/assets/jiejue/2.svg";
import advantageIcon3 from "@/assets/jiejue/3.svg";
import advantageIcon4 from "@/assets/jiejue/4.svg";
import advantageIcon5 from "@/assets/jiejue/5.svg";
import aiPlatformHeroBanner from "@/assets/jiejue/custom/ai-platform-hero-banner.svg";
import aiNativePlatformHeroBanner from "@/assets/jiejue/custom/ai-native-platform-hero-banner.svg";
import aiPlatformDeploy from "@/assets/solutions/deploy/ai-platform.svg";
import aiNativePlatformDeploy from "@/assets/solutions/deploy/ai-native-platform.svg";

const route = useRoute();
const content = computed(
  () => aiComputeSolutions[route.meta.solutionKey] || aiComputeSolutions["ai-platform"]
);
const solutionName = computed(() => content.value.title);
const heroBannerSrc = computed(() =>
  route.meta.solutionKey === "ai-native-platform"
    ? aiNativePlatformHeroBanner
    : aiPlatformHeroBanner
);
const architectureSrc = computed(() =>
  route.meta.solutionKey === "ai-native-platform"
    ? aiNativePlatformDeploy
    : aiPlatformDeploy
);

const dropcapEnabled = computed(() => /^[\u4e00-\u9fff]/.test(content.value?.background || ''));
const challengeIcons = [challengeIcon1, challengeIcon2, challengeIcon3, challengeIcon4];
const advantageIcons = [advantageIcon1, advantageIcon2, advantageIcon3, advantageIcon4, advantageIcon5];
const loaded = ref(false);

// 添加滚动动画相关的响应式变量
const backgroundVisible = ref(false);
const challengesVisible = ref(false);
const scenariosVisible = ref(false);
const architectureVisible = ref(false);
const advantagesVisible = ref(false);
const casesVisible = ref(false);

// 这里写即可，代替 export default
defineOptions({
  banner: aiPlatformHeroBanner,
});
const activeTab = ref("background");
const isScrollingProgrammatically = ref(false); // 添加标志，防止程序滚动时覆盖activeTab
const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (!el) return;

  // 立即设置activeTab，确保点击时立即高亮
  activeTab.value = id;
  history.replaceState(null, "", `#${id}`);

  // 设置标志，表示这是程序触发的滚动
  isScrollingProgrammatically.value = true;

  // 滚动到目标元素
  if (el.scrollIntoView) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  } else {
    const stickyOffset = 120;
    const y = el.getBoundingClientRect().top + window.scrollY - stickyOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }

  // 滚动完成后，重置标志，允许IntersectionObserver再次工作
  setTimeout(() => {
    isScrollingProgrammatically.value = false;
    // 不再调用updateActiveTab，保持用户点击的tab高亮
  }, 1500); // 增加延迟时间，确保滚动完全结束
};
const animationObserver = ref(null);
const navObserver = ref(null); // 添加导航观察器
let scrollTimeout = null;

const updateActiveTab = () => {
  // 如果是程序触发的滚动，不更新
  if (isScrollingProgrammatically.value) {
    console.log("Skipping update due to programmatic scroll");
    return;
  }

  const sections = ["background", "challenges", "scenarios", "architecture", "advantages"];
  const scrollPosition = window.scrollY;

  // 找出当前应该激活的区块
  let newActiveTab = "background"; // 默认为第一个区块

  // 遍历所有区块，找出当前滚动位置对应的区块
  for (let i = 0; i < sections.length; i++) {
    const section = document.getElementById(sections[i]);
    if (section) {
      const rect = section.getBoundingClientRect();
      const sectionTop = rect.top + window.scrollY;
      const sectionBottom = sectionTop + rect.height;

      // 如果当前滚动位置在区块范围内
      if (
        scrollPosition >= sectionTop - 150 &&
        scrollPosition < sectionBottom - 100
      ) {
        newActiveTab = sections[i];
        break;
      }
    }
  }

  // 更新activeTab
  if (activeTab.value !== newActiveTab) {
    console.log(
      "Updating activeTab from",
      activeTab.value,
      "to",
      newActiveTab,
      "scrollY:",
      scrollPosition,
    );
    activeTab.value = newActiveTab;
    history.replaceState(null, "", `#${newActiveTab}`);
  }
};

const handleScroll = () => {
  // 清除之前的定时器
  if (scrollTimeout) clearTimeout(scrollTimeout);

  // 设置新的定时器，延迟更新
  scrollTimeout = setTimeout(() => {
    console.log("Scroll event triggered, scrollY:", window.scrollY);
    updateActiveTab();
  }, 50);
};

// 添加一个立即执行的版本，用于测试
const handleScrollImmediate = () => {
  console.log("Scroll event triggered (immediate), scrollY:", window.scrollY);
  updateActiveTab();
};

// 使用IntersectionObserver来检测当前可见的区块
const setupIntersectionObserver = () => {
  // 创建观察器，设置阈值为0.5，表示当区块50%可见时触发
  navObserver.value = new IntersectionObserver(
    (entries) => {
      // 如果是程序触发的滚动，不更新
      if (isScrollingProgrammatically.value) {
        console.log(
          "IntersectionObserver: Skipping update due to programmatic scroll",
        );
        return;
      }

      // 只处理正在进入视口的区块，而不是正在离开的
      const enteringEntries = entries.filter((entry) => entry.isIntersecting);

      if (enteringEntries.length === 0) return;

      // 找出最接近视口中心的区块
      let closestEntry = null;
      let minDistance = Infinity;

      enteringEntries.forEach((entry) => {
        const rect = entry.target.getBoundingClientRect();
        const distance = Math.abs(
          rect.top + rect.height / 2 - window.innerHeight / 2,
        );

        if (distance < minDistance) {
          minDistance = distance;
          closestEntry = entry;
        }
      });

      if (closestEntry) {
        const sectionId = closestEntry.target.id;
        console.log(
          "IntersectionObserver: Section",
          sectionId,
          "is closest to center",
        );

        // 更新activeTab
        if (activeTab.value !== sectionId) {
          console.log(
            "IntersectionObserver: Updating activeTab from",
            activeTab.value,
            "to",
            sectionId,
          );
          activeTab.value = sectionId;
          history.replaceState(null, "", `#${sectionId}`);
        }
      }
    },
    {
      threshold: 0.2, // 当区块20%可见时触发
      rootMargin: "-100px 0px -40% 0px", // 从顶部100px和底部40%的偏移
    },
  );

  // 观察所有区块
  const sections = ["background", "challenges", "scenarios", "architecture", "advantages", "cases"];
  sections.forEach((sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      navObserver.value.observe(section);
    }
  });
};

onMounted(() => {
  // 初始化activeTab为'background'
  activeTab.value = "background";
  console.log("Initial activeTab set to:", activeTab.value);

  // 延迟设置IntersectionObserver，确保DOM已完全加载
  setTimeout(() => {
    console.log("Setting up IntersectionObserver");
    setupIntersectionObserver();

    // 初始调用一次updateActiveTab
    console.log("Initial call to updateActiveTab");
    updateActiveTab();
  }, 300);

  // 创建动画观察器
  animationObserver.value = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const targetId = entry.target.id;
          if (targetId === "background") backgroundVisible.value = true;
          if (targetId === "challenges") challengesVisible.value = true;
          if (targetId === "scenarios") scenariosVisible.value = true;
          if (targetId === "architecture") architectureVisible.value = true;
          if (targetId === "advantages") advantagesVisible.value = true;
          if (targetId === "cases") casesVisible.value = true;
        }
      });
    },
    {
      rootMargin: "-10% 0px -10% 0px",
      threshold: 0.1,
    },
  );

  // 观察所有区块元素
  const observeBlocks = () => {
    const blocks = document.querySelectorAll(".ai-platform-block");
    blocks.forEach((block) => {
      animationObserver.value.observe(block);
    });
  };

  observeBlocks();

  // 添加滚动事件监听器作为备用方案
  console.log("Adding scroll event listener (immediate)");
  window.addEventListener("scroll", handleScrollImmediate, { passive: true });
});

onBeforeUnmount(() => {
  // 清理IntersectionObserver
  if (navObserver.value) {
    console.log("Disconnecting navObserver");
    navObserver.value.disconnect();
  }

  if (animationObserver.value) animationObserver.value.disconnect();
  if (scrollTimeout) clearTimeout(scrollTimeout);
  window.removeEventListener("scroll", handleScrollImmediate);
  console.log("Scroll event listener removed (immediate)");
});
</script>

<style scoped>
@import '../../assets/css/solution-page.css';

.ai-hero-banner {
  position: relative;
  overflow: hidden;
}

.ai-hero-title {
  position: absolute;
  top: 50%;
  left: 12%;
  transform: translateY(-50%);
  font-size: 48px;
  color: var(--color-text);
  font-weight: 600;
  letter-spacing: 0.01em;
  text-shadow: 0 8px 24px rgba(255, 255, 255, 0.6);
  z-index: 2;
  pointer-events: none;
  white-space: nowrap;
}

.ai-platform-page {
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  color: var(--color-text);
}

.hero {
  position: relative;
  height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    110deg,
    #eaf2ff 0%,
    #f7fbff 40%,
    #eef5ff 60%,
    #dfeaff 100%
  );
  overflow: hidden;
}

.hero::after {
  content: "";
  position: absolute;
  inset: 0;
  background:
    radial-gradient(
      1200px 360px at 75% 20%,
      rgba(24, 144, 255, 0.18) 0%,
      rgba(24, 144, 255, 0) 60%
    ),
    radial-gradient(
      800px 300px at 20% 80%,
      rgba(64, 158, 255, 0.2) 0%,
      rgba(64, 158, 255, 0) 60%
    );
}

.hero-inner {
  position: relative;
  z-index: 1;
  max-width: 1100px;
  padding: 0 24px;
  text-align: left;
}

.hero-inner h1 {
  font-size: 40px;
  line-height: 40px;
  margin-bottom: 18px;
  color: #0f172a;
}

.hero-inner p {
  font-size: 16px;
  line-height: 1.7;
  color: #333;
}

.block {
  scroll-margin-top: 120px;
  max-width: 1420px;
  margin: 0 auto;
  padding: 60px 20px 90px 20px;
}

.ai-platform-block {
  opacity: 0;
  transform: translateY(30px);
  transition:
    opacity 0.6s ease,
    transform 0.6s ease;
}

.ai-platform-block.animate-in {
  opacity: 1;
  transform: translateY(0);
}

.block-title {
  font-size: 40px;
  line-height: 40px;
  text-align: center;
  color: #000;
  margin-bottom: 64px;
}

.case-content {
  max-width: 100%;
  margin: 0 auto;
  text-align: left;
}

.section-content-cases {
  text-align: left;
}

.section-content-cases .case-content,
.section-content-cases .case-section,
.section-content-cases .case-text,
.section-content-cases .case-list {
  text-align: left;
}

.case-content-blink {
  padding: 24px;
  border-radius: 8px;
  animation: case-blink 2.5s ease-in-out infinite;
}

@keyframes case-blink {
  0%, 100% { opacity: 1; box-shadow: 0 0 0 rgba(6, 85, 159, 0); }
  50% { opacity: 0.88; box-shadow: 0 0 28px rgba(6, 85, 159, 0.25); }
}

.case-section + .case-section {
  margin-top: 32px;
}

.case-heading {
  font-size: 22px;
  font-weight: 600;
  color: #0f172a;
  margin: 0 0 24px;
}

.case-subtitle {
  font-size: 20px;
  font-weight: 600;
  color: #06559f;
  margin-bottom: 12px;
}

.case-text {
  font-size: 14px;
  line-height: 1.8;
  color: #333;
}

.case-text-full {
  font-size: 16px;
  line-height: 1.9;
  text-align: left;
}

/* 方案背景卡片效果 + 滑动动画 */
.background-card {
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  border-radius: 8px;
  padding: 36px 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e8e8e8;
  transition: box-shadow 0.3s ease;
}

.background-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

#background.animate-in .background-card {
  animation: background-slide-in 0.7s ease-out forwards;
}

@keyframes background-slide-in {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.case-list {
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  padding-left: 0;
  list-style: none;
}

.grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}
.grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}
.grid-5 {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
}

.card {
  display: flex;
  align-items: flex-start;
  gap: 17px;
  background: #f5f7fa;
  border-radius: 6px;
  padding: 30px 30px;
  min-height: 173px;
  box-sizing: border-box;
  transition: box-shadow 0.3s ease;
}

.card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.card:hover .card-desc {
  color: #567afe;
}

.card-icon {
  flex-shrink: 0;
}
.card-text {
  display: flex;
  flex-direction: column;
  text-align: start;
}
.card-title {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  color: #000000;
  line-height: 40px;
}
.card-desc {
  font-size: 14px;
  line-height: 1.7;
  color: #666;
  transition: color 0.3s ease;
}

.scenarios {
  display: flex;
  align-items: stretch;
  position: relative;
  /* max-width: 1200px; */
  margin: 0 auto;
}

.scenario-text {
  background: #fff;
  border-radius: 4px;
  padding: 50px 0px 0px 40px;
  box-sizing: border-box;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;
  text-align: start;
}

.scenario-item {
  margin-bottom: 18px;
}
.scenario-item .item-title {
  font-size: 16px;
  line-height: 16px;
  color: #333;
  margin-bottom: 8px;
  font-family: PingFang SC;
}
.scenario-item .item-desc {
  font-size: 14px;
  line-height: 1.8;
  color: #666;
}

.scenario-image {
  background-image: url("@/assets/jiejue/ai-tiaozhan/1.jpg");
  background-size: cover;
  background-position: center;
  border-radius: 6px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  width: 629px;
  height: 369px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.scenario-image::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 40%;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0.85) 40%,
    rgba(255, 255, 255, 0) 100%
  );
  pointer-events: none;
}

/* 移动端隐藏图片的专用类 */
@media (max-width: 1200px) {
  .mobile-hidden-img {
    display: none;
  }
}

.architecture-image {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  margin: 0;
}

.architecture-caption {
  width: 100%;
  max-width: 100%;
  margin: 20px 0 0;
  font-size: 14px;
  line-height: 1.8;
  color: #666;
  text-align: left;
}

.diagram {
  display: grid;
  gap: 12px;
}
.layer {
  background: #fff;
  border: 1px solid #e6ebf5;
  border-radius: 6px;
}
.layer-title {
  padding: 10px 14px;
  font-size: 14px;
  color: #333;
  background: #f6f9ff;
  border-color: #dfe8ff;
}
.layer-title.blue {
  background: #e8f2ff;
  border-color: #cfe0ff;
}
.grid.layer-app {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  padding: 12px;
}
.grid.layer-ml {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
  padding: 12px;
}
.grid.layer-data {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
  padding: 12px;
}
.grid.layer-infra {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
  padding: 12px;
}
.grid.layer-app > div,
.grid.layer-ml > div,
.grid.layer-data > div,
.grid.layer-infra > div {
  background: #f9fbff;
  border: 1px dashed #e1e9ff;
  border-radius: 6px;
  padding: 12px;
  text-align: center;
  font-size: 13px;
}

@media (max-width: 1200px) {
  .grid-2 {
    grid-template-columns: 1fr;
  }
  .grid-4,
  .grid-5 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .hero {
    height: 280px;
  }
  .hero-inner h1 {
    font-size: 28px;
    line-height: 28px;
  }
  .product-body {
    padding: 0 16px 40px;
  }
  .block {
    padding: 56px 5%;
  }
  .grid-2 {
    grid-template-columns: 1fr;
  }
  .grid-4,
  .grid-5 {
    grid-template-columns: 1fr;
  }
  .section-nav {
    top: 56px;
    gap: 16px;
    height: 48px;
  }
  .section-nav a {
    font-size: 13px;
  }
  .grid.layer-ml,
  .grid.layer-data,
  .grid.layer-infra {
    grid-template-columns: repeat(2, 1fr);
  }
  /* 移动端隐藏图片的专用类 */
  .mobile-hidden-img {
    display: none;
  }
  /* 移动端文本容器样式优化 */
  .scenario-text {
    border-top-right-radius: 4px; /* 恢复圆角 */
    border-bottom-right-radius: 4px;
    width: 100%; /* 文本容器占据100%宽度 */
    padding: 40px 30px; /* 优化移动端内边距 */
    box-sizing: border-box;
  }
  /* 移动端布局优化 */
  .scenarios {
    flex-direction: column; /* 改为纵向布局 */
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
#advantages {
  background: linear-gradient(180deg, #f5f7fa 0%, #e0ecff 100%);
  max-width: unset;
  padding: 60px 20px 90px 20px;
}
.advantages .grid-4,
.advantages .grid-5 {
  align-items: stretch;
  gap: 16px;
  max-width: 1416px;
  margin: 0 auto;
}
.advantages .grid-5 {
  grid-template-columns: repeat(5, 1fr) !important;
}
.adv-card {
  min-height: 240px;
  position: relative;
  background: #fff;
  border-radius: 4px;
  padding: 29px;
  padding-top: 70px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  text-align: start;
}
.adv-badge {
  position: absolute;
  top: 33px;
  left: 29px;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background: #1890ff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
}
.adv-title {
  font-size: 18px;
  font-family: PingFang SC;
  color: #333;
  margin-bottom: 10px;
  font-weight: 600;
}
.adv-desc {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}
.main-content {
  background: #fff;
}
#scenarios {
  max-width: unset;
  background: #f5f7fa;
  padding: 60px 20px 90px 20px;
}

@media (max-width: 576px) {
  .product-tabs-bar {
    gap: 20px;
  }
}
</style>
